export const LANG_CURRENCY_SIGNS = {
  en: [',', '.'],
  ru: [' ', '.'],
  uk: [' ', '.'],
  default: [',', '.']
};
